// extracted by mini-css-extract-plugin
export var colorSquare = "_o8-0";
export var danger = "_o8-5";
export var lightPink = "_o8-8";
export var neutralBlue = "_o8-7";
export var neutralYellow = "_o8-6";
export var normal = "_o8-1";
export var primary = "_o8-2";
export var primaryLight = "_o8-3";
export var solidBlack = "_o8-g";
export var solidGreen = "_o8-b";
export var solidLightBlue = "_o8-d";
export var solidNavy = "_o8-c";
export var solidOrange = "_o8-f";
export var solidPink = "_o8-e";
export var solidRed = "_o8-9";
export var solidYellow = "_o8-a";
export var success = "_o8-4";